(function() {
    'use strict';
    angular
        .module('abcQualityMatchApp')
        .factory('UserPreferences', UserPreferences);

    UserPreferences.$inject = ['$resource'];

    function UserPreferences ($resource) {
        var resourceUrl =  'api/user-preferences';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'save': { method:'PUT' }
        });
    }
})();
